<script>
import Vue from 'vue'
import { GlobalBus } from '@services/bus'
import { MODAL, ACTION } from '@constants/Text'
import { ICONS } from '@modules/atendimento/constants/Text'
import apiAtendimento from '@modules/atendimento/api/apiAtendimento'
import GeneralAlert from '@modules/global/components/general-alert.vue'

const QUANTITY_OPTIONS = [
  { text: '10 mensagens', value: 10 },
  { text: '25 mensagens', value: 25 },
  { text: '50 mensagens', value: 50 },
  { text: '100 mensagens', value: 100 },
]

export default {
  name: 'ModalImportarHistorico',
  components: { GeneralAlert },
  props: {
    // API + chaves GlobalBus — default atendimento; solicitacoes injeta as suas.
    api: {
      type: Object,
      default: () => apiAtendimento,
    },
    openKey: {
      type: String,
      default: MODAL.ATENDIMENTO_IMPORTAR_HISTORICO,
    },
    importadoKey: {
      type: String,
      default: ACTION.ATENDIMENTO_HISTORICO_IMPORTADO,
    },
  },
  data() {
    return {
      icons: ICONS,
      busModal: new Vue(),
      loading: false,
      quantidade: 100,
      quantityOptions: QUANTITY_OPTIONS,
      idConversa: null,
      conversaName: '',
      reload: false,
      result: null,
      generalAlertKey: 0,
    }
  },
  computed: {
    hasResult() {
      return !!this.result
    },
  },
  created() {
    GlobalBus.$on(this.openKey, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(this.openKey, this.open)
  },
  methods: {
    clear() {
      this.loading = false
      this.quantidade = 100
      this.idConversa = null
      this.conversaName = ''
      this.reload = false
      this.result = null
      this.generalAlertKey++
    },

    open({ id_conversa, nome } = {}) {
      this.clear()
      this.idConversa = id_conversa
      this.conversaName = nome || ''
      this.busModal.$emit('dialog', true)
    },

    async importar() {
      if (this.loading) return
      if (!this.idConversa) return

      this.loading = true
      this.result = null
      try {
        const r = await this.api.importarHistorico({
          id_conversa: this.idConversa,
          quantidade: this.quantidade,
          reload: this.reload,
        })
        this.$showSnack({
          text: (r && r.message) || 'Erro inesperado',
          color: r && r.status === 200 ? 'success' : 'error',
          button: true,
        })
        if (r && r.status === 200) {
          this.busModal.$emit('dialog', false)
          GlobalBus.$emit(this.importadoKey, r.value)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    persistent
    centerAndDecreasesPadding
    maxWidth="600px"
    closeColor="#8e8e8e"
    backgroundColor="white"
  >
    <div class="pb-6">
      <div class="modal-title-container">
        <span class="modal-title">Importar Histórico</span>
      </div>

      <div class="modal-content">
        <div class="pa-4">
          <!-- Conversa name -->
          <div v-if="conversaName" class="text-center mb-4">
            <div class="az-text-small az-muted">Conversa</div>
            <div class="az-text-primary az-size-14 font-medium">
              {{ conversaName }}
            </div>
          </div>

          <!-- Quantity selector -->
          <input-by-type
            v-model="quantidade"
            type="autocomplete"
            :options="quantityOptions"
            labelExternal="Quantidade de mensagens"
            class="align-icon-search mb-3"
            dense
            outlined
            hide-details
            :disabled="loading"
            data-test="quantity-select"
          />

          <!-- Reload checkbox -->
          <v-checkbox
            v-model="reload"
            label="Recarregar do zero (apaga as mensagens atuais e reimporta)"
            class="mt-0 mb-4"
            hide-details
            dense
            :disabled="loading"
            data-test="reload-checkbox"
          />

          <!-- Warning alert -->
          <GeneralAlert :key="generalAlertKey" status="warning_v3" class="mb-3">
            <div class="az-text-primary az-size-12">
              Pode levar alguns segundos. Duplicadas serão ignoradas.
            </div>
          </GeneralAlert>
        </div>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton
        primary
        :loading="loading"
        :disabled="loading"
        @click="importar"
      >
        Importar
      </BaseButton>
    </template>
  </BaseModal>
</template>
